@if (source) {
  <h2 class="evaluatee_name">{{ source.evaluatee.fullName }}</h2>
  <p class="evaluatee_position">{{ source.evaluatee.positionTitle }}</p>
  <mat-divider></mat-divider>
  <br />
  <attributes-editor
    [dataSource]="source.editorDataSource"
    fxFlexWidth="100%"
    [useAttributeDescription]="true"
    [isPrivate]="isPrivate"
    (downloadFile)="onDownloadFile($event)"
  >
  </attributes-editor>
}
